/**
 * Bullet visual kinds, sim-safe (no pixi imports — unit tests import this).
 * A kind = shape × color lane. White cores must stay white when the rim is
 * colored, so color is BAKED into the atlas per lane instead of using tint.
 */
export const BULLET_SHAPES = ['orb', 'shard', 'ring', 'diamond'] as const;
export const BULLET_LANES = ['pink', 'orange', 'cyan'] as const;

export type BulletShape = (typeof BULLET_SHAPES)[number];
export type BulletLane = (typeof BULLET_LANES)[number];

export function bulletKindIndex(shape: BulletShape, lane: BulletLane): number {
  return BULLET_SHAPES.indexOf(shape) * BULLET_LANES.length + BULLET_LANES.indexOf(lane);
}

export const BULLET_KIND_COUNT = BULLET_SHAPES.length * BULLET_LANES.length;
/** Extra atlas cells appended after the shape×lane grid. */
export const KIND_SPARK = BULLET_KIND_COUNT;
export const KIND_GEM = BULLET_KIND_COUNT + 1;
export const ATLAS_CELL_COUNT = BULLET_KIND_COUNT + 2;

/** Shapes with a facing direction get their particle rotated to velocity. */
export function kindRotates(kind: number): boolean {
  const shape = BULLET_SHAPES[Math.floor(kind / BULLET_LANES.length)];
  return shape === 'shard';
}
